export const NEWSROOM_COLLECTION_PATH = 'newsroom';

export const NEWSROOM_SUMMARIES_COLLECTION_PATH = `${ NEWSROOM_COLLECTION_PATH }-summaries`;

// TODO: rename collection to ${ NEWSROOM_COLLECTION_PATH }-announcements-state-per-user
export const ANNOUNCEMENTS_HUB_STATE_PER_USER_COLLECTION_PATH
	= `${ NEWSROOM_COLLECTION_PATH }-whats-new-hub-state-per-user`;

export const ANNOUNCEMENTS_LAST_NEWS_COUNT = 24;
